import { render, staticRenderFns } from "./ProductUrlGroupList.vue?vue&type=template&id=030bcdac&scoped=true&"
import script from "./ProductUrlGroupList.vue?vue&type=script&lang=js&"
export * from "./ProductUrlGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030bcdac",
  null
  
)

export default component.exports